var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  AggregateRoot: () => AggregateRoot
});
class AggregateRoot {
  constructor() {
    this.domainEventQueue = [];
  }
  clearDomainEvents() {
    this.domainEventQueue = [];
  }
  domainEvents() {
    const domainEvents = this.domainEventQueue.slice();
    this.clearDomainEvents();
    return domainEvents;
  }
  registerDomainEvent(event) {
    this.domainEventQueue.push(event);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AggregateRoot
});
